let workspace = window.location.host.split('.')[0];
workspace = workspace.indexOf('localhost') !== -1 ? 'interapt' : workspace;

module.exports = {
  workspace,
  firebaseConfig: {
    apiKey: "AIzaSyCjsrDUGi6c5tAwn5E5zZ2_wKyDgUdCYMI",
    authDomain: "prism-79cae.firebaseapp.com",
    databaseURL: "https://prism-79cae.firebaseio.com",
    projectId: "prism-79cae",
    storageBucket: "prism-79cae.appspot.com",
    messagingSenderId: "409835232439"
  },
  ...(({
    local: {
      backendUrl: 'http://localhost:8080'
    },
    development: {
      backendUrl: `https://${workspace}.dev.api.myprism.io`
    },
    staging: {
      backendUrl: `https://${workspace}.staging.api.myprism.io`
    },
    production: {
      backendUrl: `https://${workspace}.api.myprism.io`
    }
  })[process.env.ENVIRONMENT || 'development'])
};



// WEBPACK FOOTER //
// ./src/globals/environment.js